"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.switchWrapperStyles = exports.switchTransformWrapper = exports.switchMainWrapper = exports.itemStyles = void 0;

var _reactEmotion = require("react-emotion");

var borderRadius = 14;

var itemStyles = function itemStyles(theme, active) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("cursor:pointer;padding:6px 20px;font-size:12px;font-weight:600;letter-spacing:0.9px;text-transform:uppercase;border-radius:", borderRadius, "px;outline:none;flex-shrink:0;transition:color 0.3s cubic-bezier(0.645,0.045,0.355,1);z-index:1;", active ? "\n    z-index: 2;\n    color: #ffffff;;\n  " : "\n    color: ".concat(theme.color.black3, ";\n  "), ";")
  );
};

exports.itemStyles = itemStyles;

var switchMainWrapper = function switchMainWrapper(theme, maxWidth) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("position:relative;max-width:", maxWidth, ";overflow:auto;::-webkit-scrollbar{display:none;}")
  );
};

exports.switchMainWrapper = switchMainWrapper;

var switchTransformWrapper = function switchTransformWrapper(theme) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("transform:translate3d(0px,0px,0px);transition:transform 0.3s cubic-bezier(0.645,0.045,0.355,1),width 0.3s cubic-bezier(0.645,0.045,0.355,1),-webkit-transform 0.3s cubic-bezier(0.645,0.045,0.355,1);z-index:1;position:absolute;left:0;top:0px;bottom:0px;-webkit-box-sizing:border-box;box-sizing:border-box;background-color:", theme.color.accent, ";-webkit-transform-origin:0 0;-ms-transform-origin:0 0;transform-origin:0 0;z-index:0;border-radius:14px;")
  );
};

exports.switchTransformWrapper = switchTransformWrapper;

var switchWrapperStyles = function switchWrapperStyles(theme) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:inline-flex;background-color:", theme.color.grey4, ";border-radius:", borderRadius, "px;width:max-content;")
  );
};

exports.switchWrapperStyles = switchWrapperStyles;